import { isPrimaryInstance } from 'bootstrapper/bootstrap';
import { getEnvironment, isProductionEnvironment } from 'bootstrapper/utils';
import { useMemo } from 'react';
import { useFrontVersion } from 'utils/version';

function getEnvLabel() {
  return getEnvironment(window.sgmeConfiguration);
}

function buildTopLabel(envLabel: string | null, version: string) {
  const isProduction = isProductionEnvironment(envLabel);
  if (isProduction) {
    return undefined;
  }
  return `${envLabel} v${version} [${isPrimaryInstance ? 'MAIN-SESSION' : 'OTHER-SESSION'}]`;
}

export function useTopLabel() {
  const envLabel = getEnvLabel();
  const version = useFrontVersion();
  return useMemo(() => buildTopLabel(envLabel, version), [envLabel, version]);
}

export function setFakeSso(mail: string | null) {
  const queryString = mail ? `?fakeSSO=${mail}` : '';
  const newUrl = `${window.location.origin + window.location.pathname}${queryString}${window.location.hash}`;
  window.location.href = newUrl;
}
